import { useState } from "react";
import { BellOff, RotateCcw, ArrowUpRight } from "lucide-react";
import { foApi } from "@/webapp/fleet-owners/api";
import { PageHead, Panel, Tag, EmptyState, Button, SEVERITY } from "@/webapp/fleet-owners/ui";

const FILTERS = ["all", "critical", "warning", "info"];

export default function Alerts({ data, reload, go }) {
  const [sev, setSev] = useState("all");
  const [cat, setCat] = useState("All");
  const cats = ["All", ...new Set(data.alerts.map((a) => a.category))];
  const rows = data.alerts.filter((a) => (sev === "all" || a.severity === sev) && (cat === "All" || a.category === cat));
  const dismiss = async (a) => { await foApi.dismissAlert(a.key); await reload(); };
  const restore = async () => { await foApi.restoreAlerts(); await reload(); };
  const count = (s) => data.alerts.filter((a) => s === "all" || a.severity === s).length;
  return (
    <>
      <PageHead eyebrow="System" title="Alerts" sub="One feed for expiring paperwork, overstays, gate flags, unsettled charges and connection status. Generated from your live records.">
        {data.dismissed_count > 0 && <Button testid="fo-alerts-restore" onClick={restore}><RotateCcw className="h-4 w-4" />Restore {data.dismissed_count} dismissed</Button>}
      </PageHead>
      <div className="fo-rise fo-rise-1 mb-4 flex flex-wrap items-center gap-2">
        {FILTERS.map((s) => <button key={s} data-testid={`fo-alerts-sev-${s}`} onClick={() => setSev(s)} className={`rounded-md border px-3 py-1.5 text-xs font-semibold capitalize transition-colors ${sev === s ? "border-[#0A234A] bg-[#0A234A] text-white" : "border-slate-200 bg-white text-slate-600 hover:border-slate-300"}`}>{s} <span className="font-mono">{count(s)}</span></button>)}
        <span className="mx-2 h-5 w-px bg-slate-200" />
        {cats.map((c) => <button key={c} data-testid={`fo-alerts-cat-${c.toLowerCase()}`} onClick={() => setCat(c)} className={`rounded-md px-2.5 py-1 text-xs font-semibold transition-colors ${cat === c ? "bg-orange-50 text-[#FF5722]" : "text-slate-500 hover:text-[#0A234A]"}`}>{c}</button>)}
      </div>
      {rows.length ? (
        <Panel className="fo-rise fo-rise-2" testid="fo-alerts-panel">
          <ul className="divide-y divide-slate-100">
            {rows.map((a) => (
              <li key={a.key} className="flex flex-col gap-3 px-5 py-4 sm:flex-row sm:items-start sm:gap-4" data-testid={`fo-alert-${a.key}`}>
                <div className="flex min-w-0 flex-1 items-start gap-3">
                <span className={`mt-1.5 h-2 w-2 flex-shrink-0 rounded-full ${a.severity === "critical" ? "bg-red-500" : a.severity === "warning" ? "bg-amber-500" : "bg-blue-500"}`} />
                <div className="min-w-0 flex-1">
                  <div className="flex flex-wrap items-center gap-2"><span className="text-sm font-semibold text-[#0A234A]">{a.title}</span><Tag tone={SEVERITY[a.severity]}>{a.severity}</Tag><span className="font-mono text-[11px] uppercase tracking-wider text-slate-400">{a.category}</span></div>
                  <p className="mt-0.5 text-sm text-slate-500">{a.detail}</p>
                </div>
                </div>
                <div className="flex gap-1 pl-5 sm:pl-0">
                  <Button variant="ghost" testid={`fo-alert-open-${a.key}`} onClick={() => go(a.tab)}>Open<ArrowUpRight className="h-3.5 w-3.5" /></Button>
                  <Button variant="ghost" testid={`fo-alert-dismiss-${a.key}`} onClick={() => dismiss(a)}><BellOff className="h-3.5 w-3.5" />Dismiss</Button>
                </div>
              </li>
            ))}
          </ul>
        </Panel>
      ) : <EmptyState icon={BellOff} testid="fo-alerts-empty" title={data.alerts.length ? "No alerts match this filter" : "All clear"} body="Alerts are generated from your vehicles, drivers, bookings and gate events." />}
    </>
  );
}
